export default __webpack_public_path__ + "static/media/hamburgur.9678025e.svg";